import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Grid, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';
import type { StyledStepStackProps } from './StepsCarouselSteps';

export const StyledHeadingBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(4),
}));

export const StyledHeadingBoxMobile = styled(StyledHeadingBox)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));

export const StyledHeadingBoxDesktop = styled(StyledHeadingBox)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
  },
}));

export const StyledAllStepsStack = styled(Stack)(({ theme }) => ({
  position: 'relative',
  '&::before': {
    // this is for the horizontal line that connects the steps
    content: '""',
    position: 'absolute',
    top: 0,
    left: theme.spacing(3.5),
    width: '1px',
    height: '100%',
    zIndex: 0,
    backgroundColor: outOfBandThemeColors.uMeds.merinoDark,
  },
}));

export const StyledStepGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'activeStep',
})<StyledStepStackProps>(({ activeStep, theme }) => ({
  flexWrap: 'nowrap',
  ...(activeStep && {
    '& > .MuiGrid-root:first-child > .MuiBox-root:first-child': {
      opacity: 1,
    },
    '& > .MuiGrid-root:last-child > .MuiBox-root': {
      paddingLeft: theme.spacing(2.5),
    },
  }),
}));

export const StyledNumberGrid = styled(Grid)(() => ({
  position: 'relative',
  paddingLeft: '0 !important',
  paddingTop: '0 !important',
  backgroundColor: outOfBandThemeColors.uMeds.merino100, // adding the background color here prevents the background line showing through the number circles with opacity
  '& > .MuiTypography-root': {
    position: 'absolute',
    zIndex: 2,
  },
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledNumberCircle = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  opacity: '0.56',
  transition: 'opacity 500ms',
  borderRadius: '50%',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: '0',
  left: '0',
  zIndex: 1,
}));

export const StyledBoxWithTransition = styled(Box)(() => ({
  transition: 'padding 500ms',
}));

export const StyledImageContainerOuter = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'relative',
  borderRadius: theme.spacing(4),
  overflow: 'hidden',
}));

export const StyledImageContainerInner = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 0,
  paddingBottom: '75%',
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    paddingBottom: '63.5%',
  },
}));

export const StyledImg = styled('img')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  objectFit: 'cover',
  width: '100%',
  height: '100%',
}));
